import { useState } from 'react';
import { FormContainer } from '../../../_core/form/form-container.component';
import {
  ITransferOwnershipContainerProps,
  TransferOwnershipNestedContainer
} from './transfer-ownership-form-nested.container';

export const TransferOwnershipContainer = (props: ITransferOwnershipContainerProps) => {
  const [success, setSuccess] = useState<string | null>(null);
  const [submitError, setSubmitError] = useState<string | null>(null);

  return (
    <FormContainer
      error={submitError}
      setError={setSubmitError}
      success={success}
      setSuccess={setSuccess}
      title="Transfer Ownership"
    >
      <TransferOwnershipNestedContainer
        onError={(e) => setSubmitError(e ?? null)}
        onSuccess={(s) => setSuccess(s ?? null)}
        {...props}
      />
    </FormContainer>
  );
};
